export const TEXT_CONFIG = {
  LOGOUT_MODAL_TEXT: 'Вы действительно хотите выйти?',
};
